import { msg } from "@lingui/core/macro";
import { createSignal, onCleanup, onMount, Show } from "solid-js";
import { CloudOff } from "lucide-solid";
import { useI18n } from "@/providers/i18n-provider";

/** Re-chequeo periódico: los eventos online/offline pueden perderse (pestaña
 * suspendida, emulación, cambios de interfaz) y un banner pegado miente. */
const POLL_MS = 3000;

export function OfflineBanner() {
  const { t } = useI18n();
  const [isOnline, setIsOnline] = createSignal(navigator.onLine);

  onMount(() => {
    const sync = () => setIsOnline(navigator.onLine);

    globalThis.addEventListener("online", sync);
    globalThis.addEventListener("offline", sync);
    const interval = setInterval(sync, POLL_MS);

    onCleanup(() => {
      globalThis.removeEventListener("online", sync);
      globalThis.removeEventListener("offline", sync);
      clearInterval(interval);
    });
  });

  // Montado SOLO cuando de verdad no hay red: un banner "colapsado pero
  // montado" seguía ocupando el árbol de accesibilidad y confundía a los
  // checks de visibilidad (el contenido clipped conserva bounding box).
  return (
    <Show when={!isOnline()}>
      <div
        class="animate-in slide-in-from-top flex h-10 items-center justify-center gap-2 bg-amber-500 px-4 text-center text-xs font-bold text-amber-950"
        role="status"
        data-testid="offline-banner"
      >
        <CloudOff class="h-4 w-4" />
        {t(msg`You are working in offline mode. Changes will sync when connection is restored.`)}
      </div>
    </Show>
  );
}
